import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
	makeStyles,
	Button
} from '@material-ui/core';

const styles = makeStyles(theme => ({
	button: {
		whiteSpace: "nowrap"
	},

	linkIcon: {
		marginLeft: theme.spacing(.5)
	}
}));

function ViewOriginalButton(props) {
	let classes = styles(),
		{extraHeaders, isTip, isGDoc, isSearch, postLink,
			className, label, iconTitle, icon} = props;
	
	if (!iconTitle) {
		if (isGDoc) {
			iconTitle = 'view current doc';
		}
		else if (isSearch) {
			iconTitle = 'view original search'
		}
		else {
			iconTitle = 'view original post';
		}
	}

	if (!label) {
		if (isGDoc) {
			label = 'Current Doc';
		}
		else if (isSearch) {
			label = 'Original Search'
		}
		else {
			label = 'Original Post';
		}
	}

	return (
		!extraHeaders || isTip ?
			<Button
				color="primary"
				target="_blank"
				href={postLink}
				disabled={!postLink}
				className={`${classes.button} ${className}`}
				startIcon={
					<FontAwesomeIcon
						icon={icon || ["far", "external-link-square"]}
						title={iconTitle} />
				}>
				<span>
					{label}
					{/*<FontAwesomeIcon
						className={classes.linkIcon}
						icon={icon || ["far", "external-link-square"]}
						title={iconTitle ? iconTitle : isGDoc ? "view current doc" : "view original post"} />*/}
				</span>
			</Button> : null
	);
}

ViewOriginalButton.propTypes = {
	className: PropTypes.string,
	extraHeaders: PropTypes.object,
	isTip: PropTypes.bool,
	isGDoc: PropTypes.bool,
	postLink: PropTypes.string,
	label: PropTypes.string,
	iconTitle: PropTypes.string,
	icon: PropTypes.array
};

export default ViewOriginalButton;